<template>
  <button
    class="btn btn-white btn-pill"
    type="button"
    :class="icon == 'trash' ? 'text-danger' : ''"
    @click="action"
    v-html="ic(icon)"
  />
</template>
<script>
import helper from "@/assets/js/helper.js";
export default {
  mixins: [helper],
  props: {
    icon: { default: "" },
    action: {
      type: Function,
      default: function () {
        return () => {};
      },
    },
  },
};
</script>